import { request } from 'ice';
import { BASEDATASERVICE, INBOUNDSERVICE } from '@/const';

// 获取工作时长
async function getLoginTime(params) {
  return await request({
    url: `${BASEDATASERVICE}/system/user/getLoginSystemTimeByToday`,
    method: 'GET',
    params,
  });
}

// 获取登录天数
async function getLoginDays(params) {
  return await request({
    url: `${BASEDATASERVICE}/system/firstLoginSystemRecord/queryDayNums`,
    method: 'GET',
    params,
  });
}

// 获取当前是否是假日
async function getHoliday(data: object) {
  return await request({
    url: `${INBOUNDSERVICE}/outboundBoard/isHoliday`,
    method: 'GET',
    params: data,
  });
}

export { getLoginTime, getLoginDays, getHoliday };
